export default __webpack_public_path__ + "static/media/21.2b729750.mp3";